import {mapGetters} from "vuex"
import {constants} from "@/const"


export const siteSectionsHelper = {
    computed: {
        ...mapGetters(["IsSectionEnabled","IsSectionEnabledAllUppercase"]),
        IsClaimsSectionEnabled: function() {
            return this.IsSectionEnabled("Claims");
        },
        IsReturnsSectionEnabled: function() {
            return this.IsSectionEnabled("Returns");
        },
        IsEntitlementsSectionEnabled: function() {
            return this.IsSectionEnabled("Entitlements");
        },
        IsReturnsCreateSectionEnabled: function() {
            return this.IsSectionEnabled("Returns.Create");
        },
        IsPartsStoreOrdersSectionEnabled: function() {
            return this.IsSectionEnabled("nGauge.Orders");
        },
        IsClaimsFreightSectionEnabled: function () {
            return this.IsSectionEnabled("Claims.Freight");
        },
        IsClaimsExtraPartsSectionEnabled: function () {
            return this.IsSectionEnabled("Claims.ExtraParts");
        },
        IsOEMManualsSectionEnabled: function () {
            return this.IsSectionEnabled("OemManuals");
        },
        IsOrderQuotesSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.Quotes");
        },
        IsOrdersQuickOrdersSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.QuickOrders");
        },
        IsOrdersOpenOrdersSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.OpenOrders");
        },
        IsOrdersBackOrdersSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.BackOrders");
        },
        IsOrdersInvoicesSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.Invoices");
        },
        IsOrdersCreditsSectionEnabled: function(){
            return this.IsSectionEnabled("Orders.Credits");
        },
    },
    methods: {
    }
}
